const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_auth/sign-in/mfa.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { SignInSearchSchema } from '@apps/main/features/auth/pages/sign-in-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_auth/sign-in/mfa')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: SignInSearchSchema
});